<template>
  <div class="package d-flex flex-column   mb-5">
    <div class="headerPackage d-flex justify-center align-center flex-column">
      <div class="price">
        <template v-if="$vuetify.rtl">
          {{ packageInfo.title }}
        </template>
        <template v-else>
          {{ packageInfo.en_title }}
        </template>
      </div>
    </div>
    <div class="bodyPackage flex-grow-1">
      <template v-if="packageInfo.currency === 'cad'">
        <span class="en_num">{{ formatAmount(packageInfo.price) }}</span>
        {{ cadLabel(true) }}
      </template>
      <template v-else>
        {{ withCurrency(packageInfo.price, packageInfo.currency, 'long') }}
      </template>
      <div
        v-if="showPreviousUsd"
        class="previousUsdHint"
      >
        <i18n path="packages.previouslyUsd">
          <span place="price" class="en_num">{{ formatAmount(packageInfo.usd_price) }}</span>
        </i18n>
      </div>
    </div>
    <div class="actionPackage text-center">
      <div class="perSessionLabel">
        <template v-if="packageInfo.currency === 'cad'">
          <span class="cadAmount" dir="ltr">
            <span class="en_num">{{ formatAmount(packageInfo.single_session_price) }}</span>
            {{ cadLabel() }}
          </span>
        </template>
        <template v-else>
          {{ withCurrency(packageInfo.single_session_price, packageInfo.currency) }}
        </template>
        {{ $t('packages.perSession') }}
      </div>
      <v-btn color="#3CBE8B" elevation="0" class="selectPackage" @click="addToCart">
        {{ $t('packages.buy') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import EventsMixins from "@/mixins/EventsMixins";
import {mapGetters} from "vuex";

export default {
  mixins: [EventsMixins],
  props: {
    packageInfo: Object,
  },
  methods: {
    formatAmount(value) {
      const amount = Number(value);
      if (Number.isNaN(amount)) {
        return value;
      }
      return amount.toFixed(2).replace(/\.00$/, "");
    },
    cadLabel(longLabel = false) {
      return this.$t(
        longLabel && this.$vuetify.rtl
          ? 'currency.dollarCanadaLong'
          : 'currency.dollarCanada'
      );
    },
    addToCart() {
      this.$emitEvent('setLoading', true)
      this.requesting('cart', 'addToCart', '', {
        package_id: this.packageInfo.id,
        addone: false
      }).then((item) => {

        let productInfo = item.data[0].items[this.packageInfo.id]
        this.WebengageAddToCart(productInfo);
        this.SendEventTrk({
          event_id: 'add_to_cart' + Date.now(),
          name: 'add_to_cart',
          email: this.profile.email,
          first_name: this.profile.firstname,
          last_name: this.profile.lastname,
          payload: {
            product_name: productInfo.item.title,
            product_id: productInfo.item.id
          }
        })
        this.GTMAddToCart(productInfo)
        this.replaceCart(item.data[0])
        this.$router.push({name: 'basket'})
        this.$emitEvent('notify', {title: 'محصول مورد نظر شما اضافه شد', color: 'green'})
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    replaceCart(cart) {
      let payload = {
        key: 'cart',
        data: [
          cart
        ]
      }
      this.$store.dispatch('setCart', payload)
      // this.prepareBasketProduct()
    },
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile'
    }),
    showPreviousUsd() {
      return this.packageInfo
        && this.packageInfo.currency === 'cad'
        && this.packageInfo.usd_price != null
        && Number(this.packageInfo.usd_price) > 0;
    },
  }

}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 600px) {
  .price {
    font-size: 12px !important;
    margin-bottom: 10px !important;
  }

  .bodyPackage {
    font-size: 15px !important;
    padding: 20px !important;
  }

  .perSessionLabel {
    font-size: 10px !important;
  }

  .package {
    min-height: 95% !important;
    height: auto !important;
  }

  .headerPackage {
    height: auto !important;
  }

  .selectPackage {
    width: 100% !important;
    height: 30px !important;
    font-size: 12px !important;
  }
}

.headerPackage {
  height: 110px;
  border-bottom: 2px solid #4597DF;
}

.package {
  overflow: hidden;
  height: 350px;
  padding: 20px;
  background: #FFFFFF;
  box-shadow: 0px 1px 14px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
}

.price {
  font-size: 20px;
  text-align: center;
  /*color: white;*/
}

.bodyPackage {
  padding: 40px;
  margin-bottom: 10px;
  font-size: 25px;
  text-align: center;
  line-height: 20pt;
  max-height: 180px;
  color: #4597DF;
}

.previousUsdHint {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: #757575;
}

.selectPackage {
  width: 192px;
  height: 48px;
  padding: 10px;
  border-radius: 15px;
  background-color: #46b1a1;
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.41;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
}

.perSessionLabel {
  color: #959595;
  margin-bottom: 5px;
}

.cadAmount {
  display: inline-block;
  direction: ltr;
  unicode-bidi: isolate;
}
</style>
